import routesJson from "../config/routes.json";
import urlsJson from "../config/urls.json";
import moment from "moment";

const _getCurrentEnv = () => {
    return window.location.host.indexOf("local") != -1 ? "dev" : window.location.host.indexOf("compass-col") != -1 ? "coll" : "prod";
};

export const isDev = () => {
    return "dev" === _getCurrentEnv();
};
export const isColl = () => {
    return "coll" === _getCurrentEnv();
};
export const isProd = () => {
    return "prod" === _getCurrentEnv();
};

export const routePath = (routeName) => {
    return `/${process.env.REACT_APP_FOLDER}${routesJson[routeName]["path"]}`;
};

export const routeNext = (routeName) => {
    return routesJson[routeName]["next"];
};

export const getUrl = (urlName) => {
    return urlsJson[_getCurrentEnv()][urlName];
};

export const getApi = () => {
    return urlsJson[_getCurrentEnv()];
};

// @todo merge with getTables
export const isTableOccasional = () => {
    const globalVarToUse = "prod" == _getCurrentEnv() ? "USR_SM_CMP_SIMULATORE_PROD_2022_TABELLE" : "USR_SM_CMP_SIMULATORE_COLL_2022_TABELLE";
    let baseTable = window[globalVarToUse]["STANDARD"];
    if (baseTable.hasOwnProperty("OCCASIONAL") && Object.keys(baseTable["OCCASIONAL"]).length) {
        try {
            const today = moment();
            const fromDate = moment(baseTable["OCCASIONAL"]["from"], "DD/MM/YYYY HH:mm");
            window.USR_OCCASIONAL_FROM = baseTable["OCCASIONAL"]["from"];
            const toDate = moment(baseTable["OCCASIONAL"]["to"], "DD/MM/YYYY HH:mm");
            window.USR_OCCASIONAL_TO = baseTable["OCCASIONAL"]["to"];
            if (today.isBetween(fromDate, toDate)) {
                return true;
            }
        } catch (error) {
            console.log("formato from/to errato", error);
            return false;
        }
    }
    return false;
};

export const getTables = () => {
    const globalVarToUse = "prod" == _getCurrentEnv() ? "USR_SM_CMP_SIMULATORE_PROD_2022_TABELLE" : "USR_SM_CMP_SIMULATORE_COLL_2022_TABELLE";
    //check for tabelle a tempo
    let baseTable = window[globalVarToUse]["STANDARD"];
    if (baseTable.hasOwnProperty("OCCASIONAL") && Object.keys(baseTable["OCCASIONAL"]).length) {
        try {
            const today = moment();
            const fromDate = moment(baseTable["OCCASIONAL"]["from"], "DD/MM/YYYY HH:mm");
            window.USR_OCCASIONAL_FROM = baseTable["OCCASIONAL"]["from"];
            const toDate = moment(baseTable["OCCASIONAL"]["to"], "DD/MM/YYYY HH:mm");
            window.USR_OCCASIONAL_TO = baseTable["OCCASIONAL"]["to"];
            if (today.isBetween(fromDate, toDate)) {
                baseTable = window[globalVarToUse]["STANDARD"]["OCCASIONAL"];
            }
        } catch (error) {
            console.log("formato from/to errato", error);
        }
    }

    return {
        simulatore: {
            codes: [baseTable["9XX"], baseTable["9XZ"]],
            params: {
                min: 1000,
                ass: "",
            },
        },
    };
};

const _cleanCurrencyValue = (value = "0") => {
    return parseFloat(value.toString().replace(",", "."));
};

export const formatCurrency = (value = "", withDecimals = true) => {
    if (value == 0) return "0,00 €";

    const formatter = new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: withDecimals ? 2 : 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        maximumFractionDigits: withDecimals ? 2 : 0, // (causes 2500.99 to be printed as $2,501)
    });
    return formatter.format(_cleanCurrencyValue(value.toString()));
};

export const formatPercentage = (value = "") => {
    return _cleanCurrencyValue(value).toFixed(2).replace(".", ",") + "%";
};

export const formatCurrencyLabel = (value = "") => {
    value = value.toString();
    const len = value.length;

    if (len > 3) {
        return value.substring(0, len - 3) + "." + value.substring(len - 3);
    }

    return value;
};

export const getCookie = (cookie) => {
    const match = document.cookie.match(new RegExp(`(^| )${cookie}=([^;]+)`));

    if (match) return match[2];

    return "";
};

export const getBrowserInfo = () => {
    if (window.navigator.userAgent) return window.navigator.userAgent.toString();
    return "";
};

export const isPhoneNumbersOnly = (val) => {
    return ["Backspace", "ArrowLeft", "ArrowRight", "Enter", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0"].includes(val);
};

export const convertRataFromPercToEuro = (rataPerc, min, max) => {
    const totRange = max - min;
    const val = (totRange * rataPerc) / 100;
    return Math.ceil((parseInt(min) + parseInt(val)) / 5) * 5;
};

export const isIOS = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /iPad|iPhone|iPod/.test(userAgent);
};
export const isAndroid = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android/i.test(userAgent);
};
